import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { IOptionType } from 'interfaces/forms';

import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { IKeyAssumptionsValuesType, keyAssumptionsToComponentMap, useGetKeyAssumptionsOptions } from './constants';
import { FinancialPlanChipSelector } from '../components/FinancialPlanChipSelector/FinancialPlanChipSelector';

export const KeyAssumptions: FC = () => {
  const { t } = useTranslation();
  const KEY_ASSUMPTIONS_OPTIONS = useGetKeyAssumptionsOptions()

  const [activeTab, setActiveTab] = useState<IOptionType>(KEY_ASSUMPTIONS_OPTIONS[0]);

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.KEY_ASSUMPTIONS,
  );

  const handleTabChange = (value: IOptionType[]) => {
    setActiveTab(value[0]);
  };

  const Component = keyAssumptionsToComponentMap[activeTab.value as IKeyAssumptionsValuesType];

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('financialPlan.title')}
          badgeText={t('financialPlan.keyAssumptions.title')}
          section={FOR_BANK_SECTIONS.FINANCIAL_PLAN}
        />
      </FormSectionCard>

      <FinancialPlanChipSelector options={KEY_ASSUMPTIONS_OPTIONS} selected={activeTab} onChange={handleTabChange} />

      <Component disabled={!canAccess} />
    </>
  );
};
